(function () {
    const SCROLL_INTERVAL_MS = 5000;
    const IDLE_RESUME_MS = 5000;
    const SCROLLER_SELECTOR = '.financials-tab .financials-preview-table-wrapper';

    let atStart = true;
    let paused = false;
    let shiftTimer = null;
    let resumeTimer = null;
    let listenersAttached = false;

    function isCoarsePointer() {
        return window.matchMedia('(any-pointer: coarse)').matches ||
            window.matchMedia('(pointer: coarse)').matches;
    }

    function isMobilePortrait() {
        return document.documentElement.classList.contains('desktop4-portrait-accepted') &&
            isCoarsePointer() &&
            window.matchMedia('(orientation: portrait)').matches;
    }

    function getScroller() {
        return document.querySelector(SCROLLER_SELECTOR);
    }

    function getMaxScroll(scroller) {
        return Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    }

    function step() {
        if (!isMobilePortrait() || paused) {
            return;
        }
        const scroller = getScroller();
        if (!scroller || scroller.offsetParent === null) {
            return;
        }
        const max = getMaxScroll(scroller);
        if (max <= 0) {
            return;
        }
        const targetLeft = atStart ? max : 0;
        atStart = !atStart;
        scroller.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }

    function scheduleResume() {
        if (resumeTimer) {
            clearTimeout(resumeTimer);
        }
        resumeTimer = setTimeout(() => {
            paused = false;
            resumeTimer = null;
        }, IDLE_RESUME_MS);
    }

    function onUserInteraction() {
        paused = true;
        scheduleResume();
    }

    function attachListeners(scroller) {
        if (!scroller || listenersAttached) {
            return;
        }
        const events = ['touchstart', 'pointerdown', 'touchmove', 'wheel'];
        events.forEach((eventName) => {
            scroller.addEventListener(eventName, onUserInteraction, { passive: true });
        });
        listenersAttached = true;
    }

    function init() {
        const scroller = getScroller();
        if (!scroller) {
            return;
        }
        attachListeners(scroller);
        if (shiftTimer) {
            return;
        }
        shiftTimer = setInterval(step, SCROLL_INTERVAL_MS);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
